export enum UserEvents {
  loggedIn = 'Logged In',
  loggedOut = 'Logged Out',
}

export interface UserEventsProps extends Record<string, unknown> {
  method: string;
}
